<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0"></h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>

      <!-- Card stats -->
      <div class="stats" v-if="!loading">
      
      <div class="card-columns">

        <!-- Leads Statuses -->
        <div class="card">
          <div class="card-header border-0">
            <div class="row align-items-center">
              <div class="col-12">
                <h3 class="mb-0">Lead Statuses</h3>
              </div>
            </div>
          </div>
          <el-table class="table-responsive table"
                    :data="leads"
                    header-row-class-name="thead-light">
            <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- / Leads Statuses -->

        <!-- Bank Application Statuses -->
        <div class="card">
          <div class="card-header border-0">
            <div class="row align-items-center">
              <div class="col-12">
                <h3 class="mb-0">Bank Application Statuses</h3>
              </div>
            </div>
          </div>
          <el-table class="table-responsive table"
                    :data="bank_applications"
                    header-row-class-name="thead-light">
            <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- / Bank Application Statuses -->

        <!-- Application Statuses -->
        <div class="card">
          <div class="card-header border-0">
            <div class="row align-items-center">
              <div class="col-12">
                <h3 class="mb-0">Application Statuses</h3>
              </div>
            </div>
          </div>
          <el-table class="table-responsive table"
                    :data="applications"
                    header-row-class-name="thead-light">
            <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- / Application Statuses -->

        <!-- POS Application Statuses -->
        <div class="card">
          <div class="card-header border-0">
            <div class="row align-items-center">
              <div class="col-12">
                <h3 class="mb-0">POS Application Statuses</h3>
              </div>
            </div>
          </div>
          <el-table class="table-responsive table"
                    :data="pos_applications"
                    header-row-class-name="thead-light">
            <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    v-bind="column"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- / POS Application Statuses -->
        
        </div>
      </div>
    </base-header>
  </div>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui'
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";

import { resourceFactory } from "../../resourceFactory";

const dashboardResource = resourceFactory.get("dashboardResource");

export default {
  components: {
    RouteBreadCrumb,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      leads: [],
      applications: [],
      bank_applications: [],
      pos_applications: [],

      tableColumns: [
          {
              prop: 'status',
              label: 'Status',
              minWidth: 200,
              sortable: false
          },
          {
              prop: 'total',
              label: 'Total',
              minWidth: 100,
              sortable: false
          },
          {
              prop: 'two',
              label: '0-2',
              minWidth: 100,
              sortable: false
          },
          {
              prop: 'six',
              label: '3-6',
              minWidth: 100,
              sortable: false
          },
          {
              prop: 'thirteen',
              label: '7-13',
              minWidth: 100,
              sortable: false
          },
          {
              prop: 'other',
              label: '14+',
              minWidth: 100,
              sortable: false
          },
      ],

      loading: false,
    };
  },
  created() {
    // Initial
    this.loading = true;
    this.fetch();
  },
  destroyed() {
  },
  methods: {
    fetch() {

      dashboardResource
        .statusBreakdown()
        .then(response => {
          
          this.leads = response.data.leads;
          this.applications = response.data.applications;
          this.bank_applications = response.data.bankApplications;
          this.pos_applications = response.data.posApplications;

          this.loading = false;

        })
        .catch(error => {
          console.log(error);
        });
    },
    }
};
</script>
<style scoped>

* >>> h5{
  font-size:20px;
}

* >>> .h2{
  font-size:40px;
}

* >>> .card-body{
  padding: 1rem;
}

* >>> .fa-spinner {
  padding:200px;
  font-size:5rem;
}

* >>> .card-columns {
  column-count: 2
}

</style>
